<template>
  <!-- Create / Edit -->
  <v-dialog v-model="dialog" width="1360" persistent fullscreen>
    <v-toolbar>
      <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeDialog()"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation autocomplete="off">
        <v-row no-gutters>
          <v-col cols="12" md="6">
            <!-- ========================================= -->
            <!--               Subordination               -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4 pr-6"
              >{{ $t("subordination") }}
              <v-divider class="ml-4"></v-divider>
            </v-subheader>
            <div class="pa-4 px-6">
              <v-autocomplete
                v-model="form.subordination.select"
                :items="form.subordination.items"
                :rules="selectRules"
                item-text="name_local"
                item-value="id_local"
                :label="$t('mLocal')"
                outlined
                dense
                return-object
                required
              ></v-autocomplete>
            </div>

            <!-- ========================================= -->
            <!--             Registration form             -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4 pr-6"
              >{{ $t("registrationForm") }}
              <v-divider class="ml-4"></v-divider>
            </v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                :label="$t('fullName')"
                v-model="form.fullName"
                :rules="fullNameRules"
                required
                clearable
                outlined
                dense
                autofocus
              ></v-text-field>

              <v-text-field
                label="CPF"
                v-model="form.doc"
                required
                clearable
                outlined
                dense
                v-mask="maskDoc"
                :rules="requiredRules"
              ></v-text-field>
              <v-text-field
                label="E-mail"
                v-model="form.email"
                :rules="emailRules"
                outlined
                dense
                name="newEmailUser"
              ></v-text-field>
              <v-row>
                <div class="col-12 col-md-6 py-0">
                  <v-text-field
                    :label="$t('mobile1')"
                    v-model="form.phone1"
                    required
                    clearable
                    outlined
                    dense
                    v-mask="maskPhone"
                    :rules="requiredRules"
                  ></v-text-field>
                </div>
                <div class="col-12 col-md-6 py-0">
                  <v-text-field
                    :label="$t('mobile2')"
                    v-model="form.phone2"
                    clearable
                    outlined
                    dense
                    v-mask="maskPhone"
                  ></v-text-field>
                </div>
              </v-row>
              <v-row>
                <div class="col-12 col-md-4 py-0">
                  <v-text-field
                    label="Cep"
                    v-model="form.zipCode"
                    :loading="loadingZipCode"
                    :disabled="disabled"
                    required
                    outlined
                    dense
                    v-mask="'#####-###'"
                    append-icon="mdi-magnify"
                    @click:append="consultZipCode(form.zipCode)"
                    @blur="consultZipCode(form.zipCode)"
                  ></v-text-field>
                </div>
                <div class="col-12 col-md-8 py-0">
                  <v-text-field
                    :label="$t('address')"
                    v-model="form.address"
                    :disabled="disabled"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-row>
              <v-row>
                <div class="col-12 col-md-6 py-0 pb-0">
                  <v-select
                    v-model="form.state.select"
                    :items="form.state.items"
                    item-text="nome"
                    item-value="id"
                    :label="$t('state')"
                    :disabled="disabled"
                    outlined
                    dense
                    return-object
                    persistent-hint
                    :loading="loadingState"
                    @change="getCitys(form.state.select.id)"
                    required
                    class="mb-2"
                    :hint="$t('toSaveStateMsg')"
                  ></v-select>
                </div>

                <div class="col-12 col-md-6 py-0">
                  <v-select
                    v-model="form.city.select"
                    :items="form.city.items"
                    item-text="nome"
                    item-value="id"
                    :label="$t('city')"
                    :disabled="disabled"
                    outlined
                    dense
                    return-object
                    required
                    class="mb-0"
                  ></v-select>
                </div>
              </v-row>
              <v-textarea
                v-model="form.informacoes"
                :label="$t('remarks')"
                outlined
                height="106"
              ></v-textarea>
            </div>
          </v-col>

          <!-- ========================================= -->
          <!--              Configurations               -->
          <!-- ========================================= -->
          <v-col cols="12" md="6">
            <v-subheader class="overline pt-4 pr-6"
              >{{ $t("settings") }}
              <v-divider class="ml-4"></v-divider>
            </v-subheader>
            <div class="pa-4 px-6">
              <v-select
                v-model="form.status.select"
                :items="form.status.items"
                item-text="name"
                item-value="id"
                :label="$t('status')"
                outlined
                dense
                return-object
                :rules="selectRules"
                required
              ></v-select>

              <v-text-field
                :label="$t('minActiveUsers')"
                v-model="form.minActiveUsersToComission"
                :rules="requiredMinActiveUsersToComission"
                onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                outlined
                dense
                type="number"
              ></v-text-field>

              <v-text-field
                :label="$t('commission')"
                v-model="form.commission"
                :rules="hasFixedCommission ? requiredComission : []"
                :disabled="hasFixedCommission === false"
                onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                required
                outlined
                dense
                type="text"
                maxlength="2"
                :counter="2"
                suffix="%"
              ></v-text-field>

              <v-text-field
                v-if="hasFeeValue"
                :disabled="form.checkboxValue"
                :label="$t('feeValue')"
                v-model="form.feeValue"
                :rules="requiredFeeValue"
                onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                outlined
                dense
                type="text"
                suffix="%"
                maxlength="2"
                :counter="2"
              ></v-text-field>

              <v-checkbox
                class="mt-1"
                v-show="!this.$route.params.id"
                v-model="form.checkboxValue"
                :label="$t('applyDefaultFee')"
                hide-details
              ></v-checkbox>

              <v-checkbox
                v-model="form.checkGuest"
                :label="$t('guestBy')"
                hide-details
              ></v-checkbox>
            </div>

            <!-- ========================================= -->
            <!--                   CPA                     -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4 pr-6" v-if="showCpa">
              {{ $t("commissionCpa") }}
              <template>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      class="mb-1 ml-1"
                      width="20px"
                      height="20px"
                    >
                      <v-icon color="info" size="medium">
                        mdi-information-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <div v-html="$t('tooltipCpa')" />
                </v-tooltip>
              </template>
              <v-divider class="ml-2"></v-divider>
            </v-subheader>
            <div class="pa-4 px-6" v-if="showCpa">
              <v-row>
                <div class="col-12 col-md-6 py-0 pb-0">
                  <v-select
                    :label="$t('commissionTypeCpa')"
                    v-model="form.comissionCpa.select"
                    :items="form.comissionCpa.items"
                    item-text="name"
                    item-value="id"
                    outlined
                    dense
                    return-object
                  ></v-select>
                </div>

                <div class="col-12 col-md-6 py-0">
                  <v-text-field
                    v-if="!(form.comissionCpa.select.id === 0)"
                    :label="$t('feeValueCommission')"
                    v-model="form.feeValueCpa"
                    :rules="getRules"
                    outlined
                    dense
                    type="text"
                    :suffix="cpaSuffix"
                    :prefix="cpaPrefix"
                    :maxlength="form.comissionCpa.select.id === 2 ? '3' : ''"
                  ></v-text-field>
                </div>
              </v-row>

              <v-row>
                <div class="col-12 col-md-6 py-0">
                  <v-text-field
                    v-if="!(form.comissionCpa.select.id === 0)"
                    :label="$t('minDepositCpa')"
                    v-model="form.minDeposit"
                    :rules="minDep"
                    outlined
                    dense
                    type="text"
                    prefix="R$"
                  ></v-text-field>
                </div>

                <div class="col-12 col-md-6 py-0">
                  <v-text-field
                    v-if="!(form.comissionCpa.select.id === 0)"
                    v-show="form.comissionCpa.select.id === 2"
                    :label="$t('maxValueCommission')"
                    v-model="form.maxComission"
                    :rules="form.comissionCpa.select.id === 2 ? docRules : []"
                    outlined
                    dense
                    type="text"
                    prefix="R$"
                  ></v-text-field>
                </div>
              </v-row>
              <div class="d-flex">
                <v-select
                  v-if="!(form.comissionCpa.select.id === 0)"
                  :label="$t('turnover')"
                  v-model="form.turnOver.select"
                  :items="form.turnOver.items"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  return-object
                ></v-select>
                <template v-if="!(form.comissionCpa.select.id === 0)">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on" class="ml-1">
                        <v-icon color="info"> mdi-information-outline </v-icon>
                      </v-btn>
                    </template>
                    <div v-html="$t('tooltipTurnover')" />
                  </v-tooltip>
                </template>
              </div>
            </div>

            <!-- ========================================= -->
            <!--                CredentialS                -->
            <!-- ========================================= -->
            <v-subheader class="overline pt-4 pr-6"
              >{{ $t("accessCredential") }}
              <v-divider class="ml-4"></v-divider>
            </v-subheader>
            <div class="pa-4 px-6">
              <v-text-field
                :label="$t('login')"
                v-model="form.login"
                :rules="usernameRules"
                required
                clearable
                outlined
                dense
                autocapitalize="off"
              ></v-text-field>
              <template v-if="edit">
                <v-btn @click="editPassword = !editPassword" class="mb-3">
                  {{ $t("changePassword") }}
                </v-btn>
              </template>
              <template v-if="editPassword || !edit">
                <v-text-field
                  :class="[
                    !form.password || show ? 'show-password' : 'hide-password',
                  ]"
                  :label="$t('password')"
                  v-model="form.password"
                  :rules="passwordRules"
                  required
                  clearable
                  outlined
                  dense
                  name="newPasswordUser"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show = !show"
                  type="text"
                  :counter="8"
                  maxlength="8"
                  autocapitalize="off"
                ></v-text-field>
                <v-text-field
                  :class="[
                    !form.confirmPassword || show1
                      ? 'show-password'
                      : 'hide-password',
                  ]"
                  :label="$t('confirmPassword')"
                  v-model="form.confirmPassword"
                  :rules="passMatch"
                  required
                  clearable
                  outlined
                  dense
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="show1 = !show1"
                  type="text"
                  :counter="8"
                  maxlength="8"
                  autocapitalize="off"
                ></v-text-field>
              </template>
            </div>
          </v-col>
        </v-row>

        <!-- ========================================= -->
        <!--                 Actions                   -->
        <!-- ========================================= -->
        <v-divider></v-divider>

        <v-alert
          class="ma-4"
          type="warning"
          v-for="item in handleError.items"
          :key="item"
        >
          {{ item }}
        </v-alert>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="info"
            :loading="loading"
            v-on:click.prevent="updateAgent"
            type="submit"
            :disabled="!valid || loading"
            >{{ $t("toSave") }}</v-btn
          >
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/validate";
import hasFeeValue from "../../../../../../../util/hasFeeValue";

export default {
  name: "local-manager-user-update",
  data: () => ({
    showEditBalance: false,
    edit: false,
    valid: false,
    loading: false,
    disabled: false,
    loadingZipCode: false,
    loadingState: false,
    show: false,
    show1: false,
    editPassword: false,
    maskDoc: "###.###.###-##",
    maskPhone: "(##) #####-####",
    handleError: {
      items: [],
    },
    form: {
      // Sector: Subordination
      subordination: {
        select: [],
        items: [],
      },
      // Sector: Registration form
      fullName: "",
      doc: "",
      phone1: "",
      phone2: "",
      email: "",
      zipCode: "",
      address: "",
      informacoes: "",
      state: {
        select: [],
        items: [],
      },
      city: {
        select: [],
        items: [],
      },
      // Sector: CredentialS
      login: "",
      password: "",
      confirmPassword: "",
      // Sector: Financial
      commission: "",
      feeValue: "",
      feeValueCpa: "",
      maxComission: "",
      status: {
        select: { id: 1, name: "Ativo" },
        items: [
          { id: 1, name: "Ativo" },
          { id: 0, name: "Bloqueado" },
        ],
      },
      turnOver: {
        select: { id: 1, name: "Ativo" },
        items: [
          { id: 1, name: "Ativo" },
          { id: 0, name: "Desativado" },
        ],
      },
      comissionCpa: {
        select: { id: 0, name: "Sem Comissionamento" },
        items: [
          { id: 2, name: "Percentual" },
          { id: 1, name: "Comissão Fixa" },
          { id: 0, name: "Sem Comissionamento" },
        ],
      },
      commissionType: "",
      checkboxValue: false,
      checkGuest: false,
    },

    // Transforma type password em type text
    fieldTypes: {
      password: "text",
    },

    //
    // Validate Forms:
    fullNameRules: [validate.required, validate.max],
    docRules: [
      validate.required,
      validate.maxValueCommission,
      validate.negativeNo,
    ],
    emailRules: [validate.validEmail],
    phone1Rules: [validate.phoneCounter],
    phone2Rules: [validate.phoneCounter2],
    selectRules: [validate.selectRequired],
    requiredRules: [validate.required, validate.max],
    requiredMinActiveUsersToComission: [validate.negativeNo],
    requiredComission: [validate.required, validate.negativeNo],
    requiredFeeValue: [validate.negativeNo, validate.max99FeeValue],
    maxValue: [validate.required, validate.maxValue],
    minDep: [
      validate.required,
      validate.maxValueCommission,
      validate.negativeNo,
    ],
    usernameRules: [
      validate.required,
      validate.usernameMax,
      validate.username,
      validate.max,
    ],
    passwordRules: [
      validate.required,
      validate.passRule,
      validate.passCaracter,
      validate.max,
    ],

    docCounter: {
      max: "Max" | 14,
    },
    required: validate.required,
    // Edit
    id_agent: "",

    initialCommissionAndFee: {
      commission: 0,
      feeValue: 0,
    },
  }),

  async created() {
    this.form.status = {
      select: { id: 1, name: this.$t("active") },
      items: [
        { id: 1, name: this.$t("active") },
        { id: 0, name: this.$t("blocked") },
      ],
    };
    this.form.turnOver = {
      select: { id: 1, name: this.$t("active") },
      items: [
        { id: 1, name: this.$t("active") },
        { id: 0, name: this.$t("disabled") },
      ],
    };
    this.form.comissionCpa = {
      select: { id: 0, name: this.$t("withoutCommission") },
      items: [
        { id: 2, name: this.$t("percentage") },
        { id: 1, name: this.$t("fixedCommission") },
        { id: 0, name: this.$t("withoutCommission") },
      ],
    };
    // =================================================== //
    // Add
    // =================================================== //
    // Retrieve Local Managers
    // Retrieve States
    let localManagersResponse = this.$request.post(
      "/administrator/affiliates/listLocals",
      { status: 1 }
    );
    let statesResponse = this.$axios.get("player/register/fetchStates");
    // Request's Simultaneously
    let localManagers = await localManagersResponse;
    let states = await statesResponse;
    // Set Responses:
    this.form.subordination.items = localManagers.dados;

    this.form.state.items = states.data.dados;

    // =================================================== //
    // IF - Edit
    // =================================================== //
    if (!this.$route.params.id) {
      return;
    }
    this.edit = true;
    let id_user = this.$route.params.id;
    let data = await this.$request.post(
      "/administrator/affiliates/getAffiliate",
      {
        id_user,
      }
    );
    const {
      endereco,
      cpf,
      email,
      id,
      id_local,
      login,
      nome,
      celular,
      documento,
      status,
      telefone,
      info,
      comissao_online,
      valor_taxa,
      cep,
      commission_type,
      min_active_users_to_commission,
      cpa_max_commission_value,
      cpa_value,
      cpa_min_deposit,
      cpa_turnover,
      cpa_type,
      show_recomendation,
    } = data.dados;

    // Registration form
    this.form.checkGuest = show_recomendation === "1" ? true : false;
    this.form.fullName = nome;
    this.form.doc = cpf;
    this.form.email = email;
    this.form.phone1 = celular;
    this.form.phone2 = telefone;
    this.form.zipCode = cep;
    this.form.address = endereco;
    this.form.informacoes = info;
    this.form.commission = this.removeDecimalIfPossible(comissao_online);
    this.form.feeValue = this.removeDecimalIfPossible(valor_taxa);
    this.form.feeValueCpa = this.removeDecimalIfPossible(cpa_value);
    this.form.maxComission = cpa_max_commission_value;
    this.form.minDeposit = cpa_min_deposit;
    this.initialCommissionAndFee = {
      commission: this.form.commission,
      feeValue: this.form.feeValue,
    };
    this.form.doc = documento;
    this.form.commissionType = commission_type;
    this.form.minActiveUsersToComission = min_active_users_to_commission;
    this.consultZipCode(cep);
    // Login
    this.form.login = login;
    // Edit
    this.id_agent = id;
    // Handle Local Manager - Subordination:
    var select = this.form.subordination.items.find((item) => {
      return item.id_local == id_local;
    });
    this.form.subordination.select = select;

    this.form.status.select = {
      id: Number(status),
      name: status == "0" ? this.$t("blocked") : this.$t("active"),
    };

    this.form.comissionCpa.select = {
      id: Number(cpa_type),
      name: cpa_type == "0" ? this.$t("blocked") : this.$t("active"),
    };

    this.form.turnOver.select = {
      id: Number(cpa_turnover),
      name: cpa_turnover == "0" ? this.$t("disable") : this.$t("active"),
    };
  },
  mounted() {
    this.retail = localStorage.getItem("operator-retail");
  },
  computed: {
    showCpa() {
      return true;
    },
    getRules() {
      switch (this.form.comissionCpa.select.id) {
        case 1:
          return this.docRules;
        case 2:
          return this.maxValue;
        default:
          return [];
      }
    },
    cpaSuffix() {
      if (this.form.comissionCpa.select.id === 2) {
        return "%";
      } else {
        return "";
      }
    },
    cpaPrefix() {
      if (this.form.comissionCpa.select.id === 1) {
        return "R$";
      } else {
        return "";
      }
    },
    hasFixedCommission() {
      if (!this.edit) {
        return true;
      }
      const commissionTypes = {
        FIXED: 1,
        VARIABLE: 2,
      };
      return this.form.commissionType == commissionTypes.FIXED;
    },
    dialog() {
      return this.$store.state.showDialog;
    },
    // // Repet password
    passMatch() {
      const rules = [];
      let required = this.$t("requiredInput");
      let repeatPassWord = this.$t("repeatThePassword");
      // Required
      if (this.form.confirmPassword) {
        const rule = (v) => !!v || required;
        rules.push(rule);
      }

      // Confirm Password
      if (this.form.password) {
        const rule = (v) => (!!v && v) === this.form.password || repeatPassWord;
        rules.push(rule);
      }

      return rules;
    },
    currencyLabel() {
      return this.$t("labelCurrency");
    },
    hasFeeValue() {
      return hasFeeValue;
    },
  },
  watch: {
    "form.comissionCpa.select"(newVal, oldVal) {
      if (
        (oldVal.id === 1 && newVal.id === 2) ||
        (oldVal.id === 2 && newVal.id === 1)
      ) {
        this.form.feeValueCpa = "";
        this.form.maxComission = "";
      }
    },
    "form.comissionCpa.select.id"(newVal) {
      if (newVal && newVal.id === 1) {
        this.form.maxComission = this.form.feeValueCpa;
      }
    },
    "form.feeValueCpa"(newVal) {
      if (this.form.comissionCpa.select.id === 1) {
        this.form.maxComission = newVal;
      }
    },
    dialog(val) {
      !val && this.$router.go(-1);
    },
  },
  methods: {
    // Consult CEP (ZipCode)
    async consultZipCode(zipCode) {
      if (!zipCode) return;
      const body = {
        cep: zipCode.replace(/[^0-9]+/g, ""),
      };
      // handle fields
      this.disabled = true;
      this.loadingZipCode = true;
      try {
        // 1. Resques CEP/ZipCode
        const response = await this.$request.post(
          "player/register/fetchCep",
          body
        );
        // 2. Handle Address:
        this.form.address = response.dados.logradouro;
        // 3. Handle Select-State:
        const uf = response.dados.uf;
        const state = this.form.state.items.filter((item) => item.uf == uf);
        this.form.state.select = state[0];
        this.getCitys(state[0].id, response.dados.cidade.toUpperCase());
      } catch (error) {
        console.log(error);
      } finally {
        // handle fields end.
        this.loadingZipCode = false;
        this.disabled = false;
      }
    },

    // getCitys
    async getCitys(stateId, nameCity) {
      this.loadingState = true;
      this.disabled = true;
      try {
        const citys = await this.$request.post("player/register/fetchCities", {
          id_state: stateId,
        });
        this.form.city.items = citys.dados;

        if (!nameCity) {
          return;
        }

        const city = this.form.city.items.filter(
          (item) => item.nome == nameCity
        );
        this.form.city.select = city[0];
        // Tratamento para o BUG da API de CEP quando envia o CEP 00000-000 ele retorna esses valores abaixo
        // Como não existe essa cidade a requisição não estava certa então foi criada essa condicional
        if (this.form.address == "LOGRADOURO" && nameCity == "CIDADE") {
          this.form.city.items.push({
            id: "00000",
            nome: "CIDADE NÃO ENCONTRADA",
          });
          const city = this.form.city.items.filter(
            (item) => item.nome == "CIDADE NÃO ENCONTRADA"
          );
          this.form.city.select = city;
          this.form.address = "RUA NÃO ENCONTRADA";
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.disabled = false;
        this.loadingState = false;
      }
    },

    // updateAgent: Create or Edit Agent.
    async updateAgent() {
      if (!this.$refs.form.validate()) {
        return;
      }

      const initialCommission = Number(this.initialCommissionAndFee.commission);
      const currentCommission = Number(this.form.commission);
      if (initialCommission != currentCommission) {
        if (!Number.isInteger(currentCommission)) {
          this.$store.commit("setFeedbackSnack", {
            msg: this.$t("commissionsOnlyInteger"),
            color: "warning",
          });
          return;
        }
      }
      const initialFee = this.initialCommissionAndFee.feeValue;
      const currentFee = Number(this.form.feeValue);
      if (initialFee != currentFee) {
        if (!Number.isInteger(currentFee)) {
          this.$store.commit("setFeedbackSnack", {
            msg: this.$t("feeValueOnlyInteger"),
            color: "warning",
          });
          return;
        }
      }

      if (this.form.phone1.length != 15) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("phoneMustCointais11Digits"),
          color: "red",
        });
        return;
      }
      if (this.form.doc.length != 14) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("CPFMustCointais11Digits"),
          color: "red",
        });
        return;
      }

      // Global progress
      this.$store.commit("setFeedbackProgress", true);
      this.loading = true;
      // Body Request Verify Login
      const verifyLogin = {
        domain: this.$localStorage.getItem("user_data").db_name,
        login: this.form.login,
      };
      // Body Request Create Agent
      const formUpdateAgent = {
        nome: this.form.fullName,
        login: this.form.login,
        password: this.form.password,
        id_gerente: this.form.subordination.select.id_local,
        email: this.form.email,
        status: this.form.status.select.id,
        cpf: this.form.doc.replace(/[^0-9]+/g, ""),
        endereco: this.form.address,
        municipio: this.form.city.select.id,
        estado: this.form.state.select.id,
        celular: this.form.phone1
          ? this.form.phone1.replace(/[^0-9]+/g, "")
          : "",
        telefone: this.form.phone2.replace(/[^0-9]+/g, ""),
        cep: this.form.zipCode.replace(/[^0-9]+/g, ""),
        informacoes: this.form.informacoes,
        comissao_online: this.form.commission,
        fee_value: this.form.feeValue,
        default_fee: this.form.checkboxValue,
        show_recomendation: this.form.checkGuest ? 1 : 0,
        min_active_users_to_commission: this.form.minActiveUsersToComission,
        cpa_type: this.form.comissionCpa.select.id,
        cpa_turnover: this.form.turnOver.select.id,
        cpa_value: this.form.feeValueCpa,
        cpa_max_commission_value: this.form.maxComission,
        cpa_min_deposit: this.form.minDeposit,
      };
      // Submit Form
      try {
        if (this.edit) {
          Object.assign(formUpdateAgent, { id_agent: this.id_agent });
        } else {
          // Add Agent - Verify existing login
          const verify = await this.$request.post(
            "main/fetchLogin",
            verifyLogin
          );
          if (verify.length == 0) {
            return;
          }
        }

        const updateEndpoint = this.edit
          ? "/administrator/affiliates/editAffiliate"
          : "/administrator/affiliates/addAffiliate";
        const result = await this.$request.post(
          updateEndpoint,
          formUpdateAgent
        );
        if (result.length == 0) {
          return;
        }
        this.$store.commit("setFeedbackSnack", {
          msg: result.messages,
          color: "success",
        });
        if (!this.edit) {
          this.$refs.form.reset();
        }
        this.$store.commit("showDialog", false);
        this.$store.commit("setRefresh", true);
      } catch (error) {
        // Multiple error handler:
        if (error.response.status == 406) {
          const items = [];
          var obj = error.response.data.messages;
          for (var [key, value] of Object.entries(obj)) {
            const item = `${key}: ${value}`;
            items.push(item);
          }
          this.handleError.items = items;
        }
      } finally {
        this.loading = false;
      }
    },
    // Close Dialog
    closeDialog() {
      this.$store.commit("showDialog", false);
    },

    removeDecimalIfPossible(string) {
      const number = Number(string);
      return Number.isInteger(number) ? parseInt(number) : number;
    },
  },
};
</script>
